module.exports = __webpack_public_path__ + "img/关于我们.34c25c09.webp";